/* src/app/questionnaire/start/start.component.scss */
/*# sourceMappingURL=start.component.css.map */
